import React, { useState } from "react";
import { Typography, Paper, Checkbox, FormGroup, FormControlLabel, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch } from "react-redux";
import {
  setInstructionContents,
  setInstructionTemplate,
} from "../../CellStepManagement/duck/actions";

import TopOfAddStepTables from "../../CellStepManagement/components/TopOfAddStepTables";
import InstructionTable from "../../CellStepManagement/components/InstructionTable";
import PaginationBlock from "./PaginationBlock";
import Instruction from "../../CellStepManagement/components/Instruction";
import Divider from "@mui/material/Divider";

const StepTypeInstruction = ({
  id,
  studyId,
  stepType,
  data,
  cells = [],
  loading,
  rowsPerPage,
  currentPage,
  onPageChange,
  onRowsPerPageChange,
  onSearch,
  setHasSearched,
  hasSearched,
  resetStateToLoading,
  onSelectItem,
  handleClick,
  resultCount,
  newItem,
  toggleItem,
  url,
  name,
  template,
  imageSrc,
  onChange,
  onNameChange,
  onTemplateChange,
  onImageChange,
  onDone,
}) => {
  const [contents, setContents] = useState({});
  const [templateValue, setTemplateValue] = useState(template || "");
  const dispatch = useDispatch();

  // state for cell modal
  const [openCellModal, setOpenCellModal] = useState(false);
  const [selectedCells, setSelectedCells] = useState([]);
  const [pendingInstructionsIds, setPendingInstructionIds] = useState([]);

  const handleContentChange = (lang, value) => {
    const updated = { ...contents, [lang]: value };
    setContents(updated);
    dispatch(setInstructionContents(updated));
  };

  const handleTemplateChange = (e) => {
    const val = e.target.value;
    setTemplateValue(val);
    dispatch(setInstructionTemplate(val));
    onTemplateChange?.(val);
  };

  // confirming cell selection
  const handleAddStepsToCells = () => {
    selectedCells.forEach((cellId) => {
      if (pendingInstructionsIds.length > 0) {
        pendingInstructionsIds.forEach((instrId) => {
          handleClick(cellId, stepType, studyId, instrId, {closeAfter: false});
        });
      } else {
        handleClick(cellId, stepType, studyId, null, {closeAfter: false});
      }
    });

    setOpenCellModal(false);
    setSelectedCells([]);
    setPendingInstructionIds([]);
    onDone?.();
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ padding: "4px 0 12px", width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              minWidth: 220,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography variant="subtitle1" style={{ lineHeight: 1.2 }}>
              Add a new instruction step
            </Typography>

            <Typography
              variant="caption"
              color="textSecondary"
              style={{
                marginTop: 2,
                lineHeight: 1.2,
              }}
            >
              An instruction step gives guidance or instructions to the
              participant in the study.
            </Typography>
          </div>



          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginLeft: "auto",
            }}
          >
            <div style={{ width: 420 }}>
              <TopOfAddStepTables
                button
                buttonText="Instruction Step"
                buttonClick={() => {
                  setPendingInstructionIds([]);
                  setOpenCellModal(true);
                }}
                textFieldLabel="Search instruction steps"
                textFieldChange={(term) => {
                  onSearch(term);
                  if (term.length > 2) {
                    setHasSearched(true);
                    resetStateToLoading();
                    onSelectItem(stepType, studyId, term, rowsPerPage, currentPage);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Paper
        elevation={0}
        square
        style={{
          padding: 0,
          borderRadius: 0,
          marginBottom: 24,
          background: "transparent",
        }}
      >
        {!newItem ? (
          <>
            <Divider
              sx={{
                borderColor: "rgba(0,0,0,0.08)",
              }}
            />

            {!hasSearched ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "64px 0",
                  color: "#888",
                  fontSize: "14px",
                }}
              >
                <SearchIcon style={{ fontSize: 50, marginBottom: 20 }} />
                <span>Search for an Instruction step</span>
              </div>
            ) : (
              <>
                <InstructionTable
                  onAddAll={(selectedIds) => {
                    setPendingInstructionIds(selectedIds);
                    setOpenCellModal(true);
                  }}
                  loading={loading}
                  data={data}
                />

                <div
                  style={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 2,
                    background: "#fff",
                    padding: "8px 0",
                    borderTop: "1px solid rgba(0,0,0,0.08)",
                  }}
                >
                  <PaginationBlock
                    resultCount={resultCount}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <Instruction
            title="Add instruction step"
            addInstructionStep={() => {
              setPendingInstructionIds([]);
              setOpenCellModal(true);
            }}
            toggleItem={toggleItem}
            name={name}
            template={templateValue}
            contents={contents}
            imageSrc={imageSrc}
            onNameChange={onNameChange}
            onTemplateChange={handleTemplateChange}
            onContentChange={handleContentChange}
            onImageChange={onImageChange}
          />
        )}
      </Paper>

      {/* cell modal select */}
      {openCellModal && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          <div style={{ background: "white", padding: 24, borderRadius: 8, width: 400 }}>
            <Typography variant="h6" style={{ marginBottom: 12 }}>
              select Cells
            </Typography>

            <FormGroup style={{ maxHeight: "60vh", overflowY: "auto" }}>
              {/* select all */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={cells.length > 0 && selectedCells.length === cells.length}
                    onChange={() => {
                      if (selectedCells.length === cells.length) {
                        setSelectedCells([]);
                      } else {
                        setSelectedCells(cells.map((c) => c.id));
                      }
                    }}
                  />
                }
                label="Select All"
              />

              {/* select individual cells */}
              {cells.map((cell) => (
                <FormControlLabel
                  key={cell.id}
                  control={
                    <Checkbox
                      checked={selectedCells.includes(cell.id)}
                      onChange={() => {
                        if (selectedCells.includes(cell.id)) {
                          setSelectedCells(selectedCells.filter((cId) => cId !== cell.id));
                        } else {
                          setSelectedCells([...selectedCells, cell.id])
                        }
                      }}
                    />
                  }
                  label={cell.cellName}
                />
              ))}
            </FormGroup>

            <div style={{marginTop: 16, display: "flex", justifyContent: "center", gap: 12}}>
              <Button onClick={() => setOpenCellModal(false)}>
                Cancel
              </Button>
              <Button
                disabled={selectedCells.length === 0}
                variant="contained"
                onClick={() => handleAddStepsToCells()}
              >
                Add to selected cells
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StepTypeInstruction;